"use client";

import jalaliPlugin from "@zoomit/dayjs-jalali-plugin";
import * as dayjs from "dayjs";
import "dayjs/locale/fa";
import relativeTime from "dayjs/plugin/relativeTime";
import timezone from "dayjs/plugin/timezone";
import updateLocale from "dayjs/plugin/updateLocale";
import utc from "dayjs/plugin/utc";

dayjs.locale("fa");
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(updateLocale);
dayjs.extend(relativeTime);
dayjs.extend(jalaliPlugin);
dayjs.calendar("jalali");
dayjs.tz.setDefault("Asia/Tehran");

type Props = {
  children: React.ReactNode;
};

export default function DayJsProvider({ children }: Props) {
  return <>{children}</>;
}
